import { render, staticRenderFns } from "./ButtonAnchor.vue?vue&type=template&id=82e1cd20&"
import script from "./ButtonAnchor.vue?vue&type=script&lang=js&"
export * from "./ButtonAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports